import {APP_INITIALIZER, Provider} from '@angular/core';
import {catchError, EMPTY} from 'rxjs';
import {Router} from '@angular/router';
import { ConfigurationService } from '../services/configuration.service';

export const ConfigurationProvider: Provider = {
  provide: APP_INITIALIZER,
  useFactory: (configurationService: ConfigurationService) => () => {
    return configurationService.load(); 
  },
  deps: [ConfigurationService],
  multi: true,
};
